import List from '~/common/components/Lists/List';
import ListItem from '~/common/components/Lists/ListItem';
import Text from '~/common/components/Texts/Text';
import type { CalculationResult } from '~/pages/IncomeCalculator/types';
import { pixelsToRem } from '~/theme/typography';

import BreakdownContainer from '../../BreakdownContainer';
import lang from '../../language.json';
import BreakdownColumnBox from '../../styles/BreakdownColumnBox';
import SingleLineValue from '../../styles/SingleLineValue';

type PensionCalculationBreakdownProps = {
  selectedResult: CalculationResult;
  onNewWindow?: () => void;
  hideAccordion?: boolean;
};

const PensionCalculationBreakdown = ({
  selectedResult,
  onNewWindow,
  hideAccordion = false,
}: Readonly<PensionCalculationBreakdownProps>) => {
  const formula = lang.FORMULAS[selectedResult.formulas[0]?.formulaId];

  return (
    <div>
      <BreakdownContainer
        header={lang.HEADERS[selectedResult.calculatorTypeId]}
        onNewWindow={onNewWindow}
        hideAccordion={hideAccordion}
      >
        {formula && (
          <>
            <SingleLineValue title={lang.MONTHLY_CALC_HEADER} value={formula} />
            <BreakdownColumnBox title={lang.CALCULATION} mb={4}>
              <List fontSize={pixelsToRem(14)}>
                {selectedResult.formulas.map(({ formulaId, formula }) => (
                  <Text as={ListItem} key={formulaId}>
                    {!formula.trim() && <br />}
                    {formula}
                  </Text>
                ))}
              </List>
            </BreakdownColumnBox>
          </>
        )}
        <SingleLineValue
          title={lang.MONTHLY_INCOME}
          value={selectedResult.calculationAmount}
          isCurrency
        />
      </BreakdownContainer>
    </div>
  );
};

export default PensionCalculationBreakdown;
